import { Directive, ElementRef, OnInit, inject } from '@angular/core';

@Directive({ selector: '[mweLookAtMeIAmTheFocusNow]' })
export class LookAtMeIAmTheFocusNowDirective implements OnInit {
  private elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.elementRef.nativeElement.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  }
}
